module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/397.fe48c02f.png";